import React from 'react'
import { UserAvatar } from '../../../components'

const ListItem = ({title, content, image, ...props}) => {
  return (
    <div className="flex" {...props}>
      <div className="mr-5">
        <UserAvatar size="48px" image={image}/>
      </div>
      <div>
        <p className="font-bold text-sm mb-1">{title}</p>
        <p className="text-sm text-gray-444">{content}</p>
      </div>
    </div>
  )
}

export { ListItem }